var map = {
	"./applab/skins": 2215,
	"./bounce/skins": 2620,
	"./craft/agent/skins": 2624,
	"./craft/code-connection/skins": 2625,
	"./craft/designer/skins": 2623,
	"./craft/simple/skins": 2622,
	"./flappy/skins": 2626,
	"./jigsaw/skins": 2639,
	"./maze/skins": 1873,
	"./netsim/skins": 2656,
	"./p5lab/skins": 2081,
	"./studio/skins": 2658,
	"./studio/starwars/skins": 2240,
	"./turtle/skins": 2271
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3951;